export const SET_APP_CONFIG = 'SET_APP_CONFIG'
